import { Skeleton } from "antd";
import type { SkeletonInputProps } from "antd/es/skeleton/Input";
import type { FC, PropsWithChildren } from "react";

export interface IotSkeletonInputProps extends PropsWithChildren<SkeletonInputProps> {
    loading?: boolean;
}

export const IotSkeletonInput: FC<IotSkeletonInputProps> = (props) => {
    const { children, active, loading = true, ...restProps } = props;

    /* This overrides the default behaviour of Ant Design */
    /* they always render the children, we will not */
    return loading ? (
        <Skeleton.Input
            {...restProps}
            active={Boolean(active)}
        />
    ) : (
        children
    );
};
